/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'iconadd': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#FFF" d="M8.467 7.838h3.67v.816h-3.67v3.67h-.815v-3.67h-3.67v-.816h3.67v-3.67h.815v3.67zm7.35.408a7.757 7.757 0 1 1-15.514 0 7.757 7.757 0 0 1 15.513 0zm-.816 0a6.941 6.941 0 1 0-13.883 0 6.941 6.941 0 0 0 13.883 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/iconadd.js